import { stringify } from '../stringify.js';
export function formatAbiItemWithArgs(_ref) {
  let {
    abiItem,
    args,
    includeFunctionName = true,
    includeName = false
  } = _ref;
  if (!('name' in abiItem)) return;
  if (!('inputs' in abiItem)) return;
  if (!abiItem.inputs) return;
  return "".concat(includeFunctionName ? abiItem.name : '', "(").concat(abiItem.inputs.map((input, i) => "".concat(includeName && input.name ? "".concat(input.name, ": ") : '').concat(typeof args[i] === 'object' ? stringify(args[i]) : args[i])).join(', '), ")");
}
//# sourceMappingURL=formatAbiItemWithArgs.js.map